import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Log } from '@/types/log'

export function getLog(uuid: string | number): Promise<AxiosResponse<Log[]>> {
  return instance.get(`/log/${uuid}`)
}
